// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1pqxc","col":"styles_col__3eyYg","actions":"styles_actions__12ADs","conflict":"styles_conflict__1KYi6"};